// extracted by mini-css-extract-plugin
export default {"tabEntry":"Tab_tabEntry__BCCSe"};